import React from 'react';
import { ArrowLeft, Plus, RefreshCw, Coins } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { formatAmount } from '../utils/format';
import LoanItem from '../components/LoanItem';

const LoansScreen = () => {
  const {
    loans,
    loading,
    setScreen,
    goToLoanDetail,
    setInitialFormData
  } = useApp();

  const totalOwed = loans.reduce((sum, loan) => {
    const balance = parseFloat(loan.balance) || 0;
    return balance < 0 ? sum + Math.abs(balance) : sum;
  }, 0);

  const totalOwedToYou = loans.reduce((sum, loan) => {
    const balance = parseFloat(loan.balance) || 0;
    return balance > 0 ? sum + balance : sum;
  }, 0);

  const handleAddLoan = () => {
    setInitialFormData({ type: 'loan' });
    setScreen('add');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 pb-20">
      <div className="bg-amber-600 text-white p-6 shadow-lg">
        <div className="flex items-center mb-4">
          <button
            onClick={() => setScreen('dashboard')}
            className="mr-4 hover:bg-white/10 rounded-lg p-1 transition"
          >
            <ArrowLeft className="w-6 h-6" />
          </button>
          <h1 className="text-2xl font-bold">Loans</h1>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
            <p className="text-amber-200 text-xs mb-1">You Owe</p>
            <p className="text-xl font-bold text-red-200">${formatAmount(totalOwed)}</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
            <p className="text-amber-200 text-xs mb-1">Owed to You</p>
            <p className="text-xl font-bold text-green-200">${formatAmount(totalOwedToYou)}</p>
          </div>
        </div>
      </div>

      <div className="p-4">
        <h2 className="text-lg font-bold text-gray-800 mb-3">All Loans ({loans.length})</h2>
        {loading ? (
          <div className="bg-white rounded-xl p-8 shadow-sm text-center">
            <RefreshCw className="w-8 h-8 mx-auto text-amber-600 animate-spin mb-2" />
            <p className="text-gray-500">Loading loans...</p>
          </div>
        ) : loans.length > 0 ? (
          <div className="space-y-3">
            {loans.map((loan, idx) => (
              <LoanItem
                key={loan.entity || idx}
                loan={loan}
                onClick={() => goToLoanDetail(loan)}
              />
            ))}
          </div>
        ) : (
          <div className="rounded-xl p-8 text-center">
            <Coins className="w-12 h-12 mx-auto text-gray-300 mb-3" />
            <p className="text-gray-400">No loans found</p>
            <p className="text-sm text-gray-400 mt-2">Add a loan transaction to track money lent or borrowed</p>
          </div>
        )}
      </div>

      <button
        onClick={handleAddLoan}
        className="fixed bottom-6 right-6 bg-amber-600 text-white p-4 rounded-full shadow-lg hover:bg-amber-700 transition"
      >
        <Plus className="w-8 h-8" />
      </button>
    </div>
  );
};

export default LoansScreen;
